<template>
	<BaseCmsShare :networks="['facebook', 'whatsapp', 'viber']" v-slot="{items, onShare}">
		<div class="share" v-if="items?.length" :class="[mode]">
			<BaseCmsLabel code="share_with_friends" class="ss-label" tag="div" />
			<div class="share-icons">
				<div v-for="network in items" :key="network" :class="['ss-item', 'ss_' + network.code]" :title="network.title" @click="onShare(network)"></div>
			</div>
		</div>
	</BaseCmsShare>
</template>

<script setup>
	const props = defineProps(['mode']);
</script>

<style scoped lang="less">
	.share{padding-top: 35px;}
	.share-icons{display: flex;}
	.ss-label{font-size: 16px; line-height: 24px; padding-bottom: 8px; font-weight: normal;}
	.ss-item{
		font-size: 0; width: 55px; height: 55px; border-radius: var(--borderRadius); border: 2px solid var(--borderColor); color: white; display: flex; justify-content: center; align-items: center; background: white; position: relative; margin-right: 5px; cursor: pointer; z-index: 99;
		&:before{.icon-fb(); font: 18px/18px var(--fonti); width: 55px; color: var(--textColor); height: 55px; display: flex; align-items: center; justify-content: center; z-index: 999; .transition(color);}
		&:after{ .pseudo(auto,auto); top: 0; left: 0; right: 0; bottom: 0; background: linear-gradient(180deg, #8E53B2 0%, #55297A 100%); opacity: 0; visibility: hidden; .transition(all);}
		@media(min-width: @h){
			&:hover{
				&:before{color: white;}
				&:after{opacity: 1; visibility: visible; border: 0; top: -2px; right: -2px; left: -2px; bottom: -2px; border-radius: var(--borderRadius);}
			}
		}
	}
	.ss_whatsapp:before{.icon-whatsapp; font: 20px/20px var(--fonti);}
	.ss_viber:before{.icon-viber; font: 17px/17px var(--fonti);}
	.ss_email:before{.icon-email; font: 14px/14px var(--fonti);}

	@media (max-width: @t){
		.share{padding-top: 20px;}
		.item, .ss-item{width: 50px; height: 50px; 
			&:before{width: 50px; height: 50px;}
		}
	}
	@media (max-width: @tp){
		.ss-label{font-size: 14px; line-height: 18px; padding-bottom: 10px;}
		.item,.ss-item{
			width: 48px; height: 48px;
			&:before{width: 48px; height: 48px;}
		}
	}
	@media (max-width: @m){
		.share{padding-top: 18px;}
		.item,.ss-item{
			&:before{width: 44px; height: 44px;}
		}
		.ss_whatsapp:before{.icon-whatsapp; font: 16px/16px var(--fonti);}
		.ss_viber:before{.icon-viber; font: 15px/15px var(--fonti);}
		.ss_email:before{.icon-email; font: 13px/13px var(--fonti);}
	}


	//FAQ
	.faq.share{
		padding-left: 29px;
		@media (max-width: @m){padding-left: 23px; padding-top: 15px;}
	}

	//CD
	.cd-share{
		.share{display: flex; flex-flow: column; padding-top: 30px;}
	}
</style>
